import About from "./about/about";
import Clients from "./clients/clients";
import Contact from "./contact/contact";
import Hero from "./hero/hero";
import Services from "./services/services";
import Talent from "./talent/talent";

/** Página principal (one-page) del sitio institucional. */
const HomeContainer = () => (
  <>
    <Hero />
    <Services />
    <About />
    <Talent />
    <Clients />
    <Contact />
  </>
);

export default HomeContainer;
